import React, { useEffect, useState } from 'react';
import Accordion from "../../components/accordion/Accordion";
import styles from './attributes.module.scss';
//import { useHttpGet } from "../../components/hooks/useHttp";
import * as utils from '../../utils/utils';
import * as constants from "../../../src/utils/constant";

function StrategicAcctAttribute(props) {
    console.log("Strategic Accounts -- Attributes", props)
    //const { code } = props;
    //const [customers, setCustomers] = useState(null)
   // const [customerSegment, setCustomerSegment] = useState(null)
    const [productDivision, setProductDivision] = useState(null)

    const [open_backorder, setOpen_Backorder] = useState(null)
    const [ofmBackOrder, setOFMBackOrder] = useState(null)//Add Revenue Distribution by orderFulfillment Backorder
    const [AR, setAR] = useState(null)
   // const [subRegionDetails, setSubRegionDetails] = useState(null)
    const [strategicAccountsDetails, setStrategicAccountsDetails] = useState(null)
    const [ofm, setOFM] = useState(null)//Add Revenue Distribution by order fulfillment method
    const [omc, setOMC] = useState(null)//Add Revenue Distribution by order mode channel
   // const [skus, setskus] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [region] = useState(JSON.parse(sessionStorage.getItem("selectedRegion")));//EMEA Release- to fetch region specific data
    const [nsgns, setNsgns] = useState(null) //addded for Included Accounts accordion
    const [accounts, setAccounts] = useState(null) //addded for Included Accounts accordion

    const processData = (fetchedData) => {

        const strategicAccountsDetails = { ...fetchedData }

        console.log("Strategic Account Fetched Data",strategicAccountsDetails)

        //addded for Strategic Tier1- Included Accounts accordion
        if (strategicAccountsDetails && strategicAccountsDetails.revenueDistribution && strategicAccountsDetails.revenueDistribution.nsgn &&
            strategicAccountsDetails.revenueDistribution.nsgn.length && Object.keys(strategicAccountsDetails.revenueDistribution.nsgn[0]).length) {
            const nsgns = [...strategicAccountsDetails.revenueDistribution.nsgn]
            setNsgns([...nsgns.sort(utils.sorting("name", "string", true))])
        }

        //addded for Top 5 Accounts accordion
        if (strategicAccountsDetails && strategicAccountsDetails.revenueDistribution && strategicAccountsDetails.revenueDistribution.accounts &&
            strategicAccountsDetails.revenueDistribution.accounts.length && Object.keys(strategicAccountsDetails.revenueDistribution.nsgn[0]).length) {
            const top5Accounts = [...strategicAccountsDetails.revenueDistribution.accounts]
            setAccounts([...top5Accounts.sort(utils.sorting('revenue', "number", false))])
        }

        if (strategicAccountsDetails.revenueDistribution && strategicAccountsDetails.revenueDistribution.productDivisions) {
            const productDivision = [...strategicAccountsDetails.revenueDistribution.productDivisions]
            console.log("Strategic Account--Product Divisions", productDivision)
            setProductDivision([...productDivision.sort(utils.sorting('revenue', "number", false))])
        }
        //Add Revenue Distribution by order Mode Entry method
        if (strategicAccountsDetails && strategicAccountsDetails.revenueDistribution && strategicAccountsDetails.revenueDistribution.omc &&
            strategicAccountsDetails.revenueDistribution.omc.length > 0) {
            const omc = [...strategicAccountsDetails.revenueDistribution.omc]
            setOMC([...omc.sort(utils.sorting('revenue', "number", false))])
        }

        //Add Revenue Distribution by order fulfillment method
        if (strategicAccountsDetails && strategicAccountsDetails.revenueDistribution && strategicAccountsDetails.revenueDistribution.ofm &&
            strategicAccountsDetails.revenueDistribution.ofm.length && Object.keys(strategicAccountsDetails.revenueDistribution.ofm[0]).length) {

            const ofms = [...strategicAccountsDetails.revenueDistribution.ofm]
            setOFM([...ofms.sort(utils.sorting('revenue', "number", false))])
        }

        //Add Revenue Distribution by BackOrder - order fulfillment method
        if (strategicAccountsDetails && strategicAccountsDetails.revenueDistribution && strategicAccountsDetails.revenueDistribution.backorder_ofm &&
            strategicAccountsDetails.revenueDistribution.backorder_ofm.length && Object.keys(strategicAccountsDetails.revenueDistribution.backorder_ofm[0]).length) {

            let newBackOrderData = utils.getOfmBOData(strategicAccountsDetails.revenueDistribution.backorder_ofm);
            const backorder_ofm = [...newBackOrderData]
            setOFMBackOrder([...backorder_ofm.sort(utils.sorting('id', "number", true))])
        }

        const open_backorder = {
            open: strategicAccountsDetails.openorder,
            back: strategicAccountsDetails.backorder
        }
        setOpen_Backorder(open_backorder)
        const open_dueAR = {
            open: strategicAccountsDetails.open_ar_amount,
            due: strategicAccountsDetails.past_due_ar_amount
        }
        setAR(open_dueAR)
        return strategicAccountsDetails
    };

    const getStrategicAttrData = (result) => {

        const strategic_hits = (result && result.hits && result.hits.hits && result.hits.hits.length > 0) ? result.hits.hits[0] : [];
        let strategicAccountsAttrData = (strategic_hits ? strategic_hits['_source']['strategicAccounts'] : []);
        let filterStrategicAttrData = strategicAccountsAttrData.filter(item => (item.company_region.toLowerCase() === region.toLowerCase()))[0]
        return filterStrategicAttrData;
    };

    useEffect(() => {

        setIsLoading(true)
        const input = {
            name: constants.StrategicAccounts_Attributes_Index,
            queryParams: {
                "query": {
                    "match_all": {}
                }
            }
        }
        utils.getDataES('-elasticsearch', 'POST', input)
            .then(resp => {
                let strategicESData = getStrategicAttrData(resp.data);
                let result = processData(strategicESData)
                console.log("Result of Formatted Strategic", result)
                setStrategicAccountsDetails(result)
                props.isattrSectionLoaded(true);
                setIsLoading(false)
            }).catch(err => setIsLoading(false))
    }, [])

    return (
        strategicAccountsDetails && <div className={styles.attributes}>
            <div className={styles.attributesHeader}>{`Strategic Accounts - ${region} (Aggregate View)`}</div>
            <div className={styles.attributesBody}>        
                <div>
                    {
                        <Accordion
                            title="Included NSGN Accounts"
                            type="tier1"
                            list={nsgns}
                        />
                    }
                    {
                        <Accordion
                            title="Top 5 Accounts by Revenue​ ($M)"
                            type="accounts"
                            accounts={accounts}
                            voiceRevenue={strategicAccountsDetails.totalRevenue}
                        />
                    }
                    <div className={styles.groupTopSection}>
                        <div className={styles.innerLayout}>
                           <div className={styles.bodyTitle}>VOICE YTD Revenue​</div>
                           <div className={styles.bodyValue}>{(strategicAccountsDetails.totalRevenue !== undefined) ? '$' + utils.convertToInternationalCurrencySystem(strategicAccountsDetails.totalRevenue.toFixed(2)) : '-'}</div>
                        </div>
                        <div className={styles.innerLayout}>
                           <div className={styles.bodyTitle}>VOICE YoY Growth​</div>
                           <div className={styles.bodyValue}>{(strategicAccountsDetails.YTDGrowth !== undefined) ? strategicAccountsDetails.YTDGrowth.toFixed(2) + '%' : '-'}</div>
                        </div>
                        <div className={styles.innerLayout}>
                           <div className={styles.bodyTitle}>VOICE QoQ Growth​</div>
                           <div className={styles.bodyValue}>{(strategicAccountsDetails.QoQGrowth !== undefined) ? strategicAccountsDetails.QoQGrowth.toFixed(2) + '%' : '-'}</div>
                        </div>
                    </div>
                    {
                        <Accordion
                            title="Revenue Distribution by Fulfillment Method (YTD)"
                            type="OFM"
                            list={ofm}
                        />
                    }
                    {
                        <Accordion
                            title="Revenue Distribution by Order Entry Channel (YTD)"
                            type="OMC"
                            list={omc}
                        />
                    }
                    {
                       <Accordion
                            title="Revenue Distribution by Product Divisions (YTD)"
                            type="productDivision"
                            list={productDivision}
                        /> 
                    }

                    {<Accordion title="Open Order & Backorder"
                        type="openOrder"
                        open_backorder={open_backorder}
                        strategicAccountsDetails={strategicAccountsDetails}
                        ofmBackOrderList={ofmBackOrder}
                    />}
                    {<Accordion title="Accounts Receivable"
                        type="accountReceivable"
                        open_dueAR={AR}
                        strategicAccountsDetails={strategicAccountsDetails}
                    />}

                </div>
            </div>
        </div>)

}

export default StrategicAcctAttribute
